module.exports = __webpack_public_path__ + "img/escalator.da750a76.svg";